import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import aboutImg from "../../assets/images/home/about_us.svg";

export default function AboutUs({ aboutUs }) {
  return (
    <section className="about-us my-5">
      <Container>
        <Row className="align-items-center pb-5">
          <Col md={5} className="mb-3">
            <div className="about-images d-flex flex-wrap gap-2">
              <img
                src={aboutImg}
                alt="About Gujarati Samaj"
                className="img-fluid"
              />
            </div>
          </Col>
          <Col md={6} className="ms-auto">
            <h2 className="mb-3 h1">About Us</h2>
            <p className="f-16">
              Gujarati Samaj of Tampa Bay (GSTB) is a vibrant cultural
              organization dedicated to preserving and promoting Gujarati
              heritage, culture, and traditions in the Tampa Bay area. We bring
              together Gujaratis from all backgrounds and regions of Gujarat to
              celebrate our rich cultural identity.
            </p>
            <p className="f-16">
              Our community organizes cultural events, festivals, educational
              programs, and social gatherings that strengthen bonds among
              members while sharing our beautiful traditions with the broader
              community.
            </p>


            {/* -------------------------Dynamic content here------------------------ */}
            {/* {aboutUs?.content && (
              <div
                className="f-16"
                dangerouslySetInnerHTML={{ __html: aboutUs?.content || "" }}
              />
            )} */}

            
            <div className="mb-3">
              <h3 className="about-sub-title fw-semibold">Cultural Events</h3>
              <p className="f-16">
                Experience traditional festivals, music, dance, and celebrations that keep our heritage alive
              </p>
            </div>
            <div className="mb-3">
              <h3 className="about-sub-title fw-semibold">Educational Programs</h3>
              <p className="f-16">
                Connect with fellow Gujaratis, make lasting friendships, and build a strong community
              </p>
            </div>
            <div className="mb-3">
              <h3 className="about-sub-title fw-semibold">Community Unity</h3>
              <p className="f-16">
                Connect with fellow Gujaratis, make lasting friendships, and
                build a strong community
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
